<template>
  <div id="app">
    <FloatingAlert language="pt-BR" />
    <NewUpdateCmp />

    <TopMenuCmp class="c2b-hidden-mobile" />
    <LeftMenuCmp @oncollapsed="handleCollapse" class="c2b-hidden-mobile" />
    <BottomMenuCmp class="c2b-shown-mobile" />

    <main :class="{
        'left-menu-is-collapsed': isLeftMenuCollapsed,
      }">
      <router-view />
    </main>

    <FooterCmp />
  </div>
</template>

<script>
import Vue from 'vue';
import VueFloatingAlert from 'vue-floating-alert';
import VueCurrencyFilter from 'vue-currency-filter';
import TopMenuCmp from '@/menu/components/TopMenuCmp';
import LeftMenuCmp from '@/menu/components/LeftMenuCmp';
import BottomMenuCmp from '@/menu/components/BottomMenuCmp';
import LoadingCmp from '@/utils/components/LoadingCmp';
import NothingFoundCmp from '@/utils/components/NothingFoundCmp';
import BreadcrumbCmp from '@/utils/components/BreadcrumbCmp';
import ListCountCmp from '@/utils/components/ListCountCmp'
import NewUpdateCmp from '@/utils/components/NewUpdateCmp'
import FooterCmp from '@/footer/components/FooterCmp'
import VueCalendar from 'v-calendar'
import Multiselect from 'vue-multiselect'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import addHighchartsMore from 'highcharts/highcharts-more'
import addHighchartHeatMap from 'highcharts/modules/heatmap'
import addHighchartTreeMap from 'highcharts/modules/treemap'
import SwitchToggleCmp from '@/utils/components/SwitchToggleCmp'
import JsonToCSV from 'vue-json-csv'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'v-calendar/lib/v-calendar.min.css'
import 'popper.js';
import 'bootstrap';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faChartLine,
  faClipboardList,
  faTruckLoading,
  faCubes,
  faPuzzlePiece,
  faBell,
  faChevronRight,
  faSyncAlt,
  faSortDown,
  faHourglass,
  faHourglassStart,
  faCheck,
  faExclamationTriangle,
  faEllipsisV,
  faShippingFast,
  faMoneyBillWave,
  faTimes,
  faEquals,
  faCalendarAlt,
  faRobot,
  faBan,
  faTags,
  faUser,
  faPlusCircle,
  faCrown,
  faCloudDownloadAlt,
  faBox,
  faPlus,
  faSkull,
  faExternalLinkAlt,
  faCheckCircle,
  faWindowClose,
  faHandshake,
  faSmile,
  faChevronCircleLeft,
  faChevronCircleRight,
  faThumbsUp,
  faFlagCheckered,
  faEye,
  faThList,
  faSitemap,
  faSave,
  faInfoCircle,
  faEdit,
  faTruckMoving,
  faLink,
  faImages,
  faCircle,
  faTrash,
  faTrashAlt,
  faCogs,
  faInfo,
  faChevronDown,
  faChevronUp, 
  faStoreAlt,
  faFileDownload, 
  faComments,
  faHome,
  faDollarSign,
  faUsers,
  faUserTie,
  faPowerOff,
  faAddressBook,
  faTasks,
} from '@fortawesome/free-solid-svg-icons'
import { mapState } from 'vuex';

library.add(
  faChartLine, 
  faClipboardList, 
  faTruckLoading,
  faCubes,
  faBell,
  faPuzzlePiece,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSyncAlt,
  faSortDown,
  faHourglassStart,
  faCheck,
  faCheckCircle,
  faExclamationTriangle,
  faEllipsisV,
  faShippingFast,
  faMoneyBillWave,
  faTimes,  
  faEquals,
  faCalendarAlt,
  faRobot,
  faBan,
  faTags,
  faUser,
  faPlusCircle,
  faWindowClose,
  faCrown,
  faCloudDownloadAlt,
  faBox,
  faPlus,
  faSkull,
  faExternalLinkAlt,
  faHandshake,
  faChevronRight,
  faChevronCircleLeft,
  faChevronCircleRight,
  faSmile,
  faThumbsUp,
  faFlagCheckered,
  faEye,
  faThList,
  faSitemap,
  faSave,
  faInfoCircle,
  faInfo,
  faEdit,
  faTruckMoving,
  faLink,
  faImages,
  faCircle,
  faTrashAlt,
  faCogs,
  faStoreAlt,
  faFileDownload,
  faComments,
  faHome,
  faDollarSign,
  faUsers,
  faUserTie,
  faPowerOff,
  faAddressBook,
  faTasks,
)

addHighchartsMore(Highcharts)
addHighchartHeatMap(Highcharts)
addHighchartTreeMap(Highcharts)

Vue.use(HighchartsVue)
Vue.use(VueCalendar)
Vue.use(VueFloatingAlert)
Vue.use(VueCurrencyFilter,
{
  symbol : 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

Highcharts.setOptions({
  colors: [
    '#00a8ff',    
    '#f7b731',
    '#4b7bec',
    '#26de81',
    '#9c88ff',
    '#2296ad',
    '#8b75fa',
    '#f966e0',
    '#f97a61',
    '#716c5f',
    '#cd9629',
    '#b4fce4',
  ],
  lang: {
    decimalPoint: ',',
    loading: 'Carregando...',
    noData: 'Sem informações',
  },
  chart: {
    style: {
      fontFamily: 'monospace',
      letterSpacing: '1px',
    },
  },
});

Vue.component('multiselect', Multiselect)
Vue.component('fa', FontAwesomeIcon)
Vue.component('Loading', LoadingCmp)
Vue.component('Breadcrumb', BreadcrumbCmp)
Vue.component('NothingFound', NothingFoundCmp)
Vue.component('SwitchToggle', SwitchToggleCmp)
Vue.component('ListCount', ListCountCmp)
Vue.component('jsonToCsv', JsonToCSV)

export default {
  name: 'App',
  data() {
    return {
      isLeftMenuCollapsed: false,
    }
  },
  components: {
    TopMenuCmp,
    LeftMenuCmp,    
    BottomMenuCmp,
    FooterCmp,
    NewUpdateCmp,
  }, 
  methods: {
    handleCollapse(ev) {
      this.isLeftMenuCollapsed = ev.isCollapsed;
    },
  },
  computed: {
    ...mapState({
      subscriber: state => state.subscriber,
    }),
  },
}
</script>

<style lang="scss">
@import './utils/styles/overrides.scss';
@import './utils/styles/common.scss';
@import './utils/styles/constants.scss';

html, body {
  background-color: $bg-default-color;
}

#app {
  font-family: 'Source Sans Pro', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  height: 100vh;
}
</style>
